import SelectComponent from "@via/components/select/select";
import { isSelectOption } from "@via/utils/interfaces";
import { RUN_STATUS_OPTIONS } from "@via/hooks/runs-filter-types.ts";

interface StatusValueInputProps {
  value: string;
  onChange: (value: string) => void;
}

export default function StatusValueInput({
  value,
  onChange,
}: StatusValueInputProps) {
  return (
    <SelectComponent
      name="statusValueInput"
      options={RUN_STATUS_OPTIONS}
      value={
        value
          ? (RUN_STATUS_OPTIONS.find(opt => opt.value === value) ?? null)
          : null
      }
      onChange={selected => {
        if (isSelectOption(selected)) {
          onChange(selected.value as string);
        }
      }}
      placeholder="Select status"
      isSearchable={true}
    />
  );
}
